module.exports = __webpack_public_path__ + "5dc053f1fbe5f858f3e3a9019d2b8cbd.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/games/coh_image_2.png
// module id = 294
// module chunks = 0